import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoaderKeys } from 'src/app/core/constants/constants';
import {
  EmailExistsRequest,
  ResetPasswordEmailRequest,
  ResetPasswordRequest,
  SignupRequest,
  SigninRequest,
  VerifyCodeRequest,
  GoogleSignUpRequest,
  CheckTokenExpiryRequest,
  OmsUserSigninRequest,
  ValidateShortCodeRequest,
  VerifyGoogleRecaptchaV3TokenRequest,
  LoginWithFacebookRequest,
  LoginWithFacebookSdkAccessTokenRequest,
  LoginWithFacebookResponse,
  ShopifySignUpRequest,
  ShopifySignUpResponse,
  CompleteSignUpRequest,
  CompleteSignUpResponse,
  CompleteSignUpWithFacebookRequest,
  CompleteSignUpWithFacebookSdkAccessTokenRequest,
  CompleteSignUpWithGoogleRequest,
  SendOTPAnonymousRequest,
  SendOTPResponse,
  SendOTPRequest,
  ValidateOTPAnonymousRequest,
  ValidateOTPResponse,
  ValidateOTPRequest,
  CheckIfPasswordExistsRequest,
  CheckIfPasswordExistsResponse,
  EmailExistsResponse,
  AddPasswordRequest,
  AddPasswordResponse,
} from 'src/app/core/grpc-models/Account_pb';
import { AccountProtoService } from 'src/app/core/grpc-services/Account_pb_service';
import { GrpcService } from 'src/app/core/shared-services/grpc.service';
import { TokenService } from 'src/app/core/shared-services/token.service';

@Injectable({
  providedIn: 'root',
})
export class UserAccountService {
  constructor(
    private readonly grpcService: GrpcService,
    private readonly tokenService: TokenService
  ) { }

  public signUp(request: SignupRequest) {
    return this.grpcService.grpcUnaryService(request, AccountProtoService.Signup, undefined, true, undefined);
  }

  public googleSignup(request: GoogleSignUpRequest) {
    return this.grpcService.grpcUnaryService(request, AccountProtoService.GoogleSignUp, undefined, true);
  }

  public userLogin(request: SigninRequest) {
    return this.grpcService.grpcUnaryService(request, AccountProtoService.Signin, undefined, true, LoaderKeys.UserLoginKey);
  }

  public omsUserLogin(request: OmsUserSigninRequest) {
    return this.grpcService.grpcUnaryService(request, AccountProtoService.OmsUserSignin, undefined, true, LoaderKeys.OmsUserLoginKey);
  }


  public VerifyCode(request: VerifyCodeRequest) {
    return this.grpcService.grpcUnaryService(request, AccountProtoService.VerifyCode, undefined, true, LoaderKeys.verifyCodeKey);
  }

  public sendResetPasswordEmail(request: ResetPasswordEmailRequest) {

    return this.grpcService.grpcUnaryService(request, AccountProtoService.ResetPasswordEmail, undefined, true, LoaderKeys.ForgotPasswordEmailKey);
  }

  public resetPassword(request: ResetPasswordRequest) {
    return this.grpcService.grpcUnaryService(request, AccountProtoService.ResetPassword, this.tokenService.getMetaData(), true, LoaderKeys.ResetPasswordKey);
  }

  public checkIfEmailExits(request: EmailExistsRequest) : Promise<EmailExistsResponse.AsObject> {
    return this.grpcService.grpcUnaryService(request, AccountProtoService.CheckIfEmailExists, undefined);
  }

  public verifyEmail(request: EmailExistsRequest) {
    return this.grpcService.grpcUnaryService(request, AccountProtoService.CheckIfEmailExists, undefined, false, LoaderKeys.ForgotPasswordEmailKey);
  }

  public checkTokenExpiry() {
    let request = new CheckTokenExpiryRequest();
    request.setToken(localStorage.getItem('token') + '')
    return this.grpcService.grpcUnaryService(request, AccountProtoService.CheckTokenExpiry, undefined, false, undefined);
  }


  public validateShortCode(request: ValidateShortCodeRequest) {
    return this.grpcService.grpcUnaryService(request, AccountProtoService.ValidateShortCode, undefined, false, undefined);
  }

  public verifyGoogleRecaptchaV3Token(request: VerifyGoogleRecaptchaV3TokenRequest) {
    return this.grpcService.grpcUnaryService(
      request,
      AccountProtoService.VerifyGoogleRecaptchaV3Token, undefined, false, undefined
    );
  }

  public loginWithFacebook(request: LoginWithFacebookRequest): Promise<LoginWithFacebookResponse.AsObject> {
    return this.grpcService.grpcUnaryService(
      request,
      AccountProtoService.LoginWithFacebook, undefined, true, undefined
    );
  }

  public signUpWithFacebookSdkAccessToken(request: LoginWithFacebookSdkAccessTokenRequest): Promise<LoginWithFacebookResponse.AsObject> {
    return this.grpcService.grpcUnaryService(
      request,
      AccountProtoService.SignUpWithFacebookSdkAccessToken, undefined, true, undefined
    );
  }

  public shopifySignUp(request: ShopifySignUpRequest): Promise<ShopifySignUpResponse.AsObject> {
    return this.grpcService.grpcUnaryServiceWithError(
      request,
      AccountProtoService.ShopifySignUp, undefined, undefined
    );
  }

  public CompleteSignUp(request: CompleteSignUpRequest) : Promise<CompleteSignUpResponse.AsObject>{
      return this.grpcService.grpcUnaryService(
        request,
        AccountProtoService.CompleteSignUp,
        this.tokenService.getMetaData(), true, LoaderKeys.UserSignupKey
      );
  }

  public CompleteSignUpWithFacebook(request: CompleteSignUpWithFacebookRequest) : Promise<CompleteSignUpResponse.AsObject>{
    return this.grpcService.grpcUnaryService(
      request,
      AccountProtoService.CompleteSignUpWithFacebook,
      this.tokenService.getMetaData(), true, LoaderKeys.UserSignupKey
    );
  }

  public CompleteSignUpWithFacebookSdkAccessToken(request: CompleteSignUpWithFacebookSdkAccessTokenRequest) : Promise<CompleteSignUpResponse.AsObject>{
    return this.grpcService.grpcUnaryService(
      request,
      AccountProtoService.CompleteSignUpWithFacebookSdkAccessToken,
      this.tokenService.getMetaData(), true, LoaderKeys.UserSignupKey
    );
  }

  public CompleteSignUpWithGoogle(request: CompleteSignUpWithGoogleRequest) : Promise<CompleteSignUpResponse.AsObject>{
    return this.grpcService.grpcUnaryService(
      request,
      AccountProtoService.CompleteSignUpWithGoogle,
      this.tokenService.getMetaData(), true, LoaderKeys.UserSignupKey
    );
  }

  public SendOTPAnonymous(request: SendOTPAnonymousRequest): Promise<SendOTPResponse.AsObject>{
    return this.grpcService.grpcUnaryService(
      request,
      AccountProtoService.SendOTPAnonymous,
      undefined, true, LoaderKeys.SendOTP
    );
  }

  public SendOTP(request: SendOTPRequest): Promise<SendOTPResponse.AsObject>{
    return this.grpcService.grpcUnaryService(
      request,
      AccountProtoService.SendOTP,
      this.tokenService.getMetaData(),
      true, LoaderKeys.SendOTP
    );
  }

  public ValidateOTPAnonymous(request: ValidateOTPAnonymousRequest) : Promise<ValidateOTPResponse.AsObject>{
    return this.grpcService.grpcUnaryService(
      request,
      AccountProtoService.ValidateOTPAnonymous,
      undefined, true, LoaderKeys.ValidateOTP
    );
  }

  public ValidateOTP (request: ValidateOTPRequest) : Promise<ValidateOTPResponse.AsObject>{
    return this.grpcService.grpcUnaryService(
      request,
      AccountProtoService.ValidateOTP,
      this.tokenService.getMetaData(), true, LoaderKeys.ValidateOTP
    );
  }

  public checkIfPasswordExists(request: CheckIfPasswordExistsRequest) : Promise<CheckIfPasswordExistsResponse.AsObject>{
    return this.grpcService.grpcUnaryService(
      request,
      AccountProtoService.CheckIfPasswordExists,
      undefined, false, LoaderKeys.CheckIfPasswordExists
    );
  }

  public addPassword (request: AddPasswordRequest) : Promise<AddPasswordResponse.AsObject> {
    return this.grpcService.grpcUnaryService(
      request,
      AccountProtoService.AddPassword,
      this.tokenService.getMetaData(), true, LoaderKeys.AddPassword
    );
  }
}
